export default function Footer () {
    return (
        
        <div className="footer-container text-2xl mx-auto w-full">
        <div className="footer bg-[#4CAF50] w-full pb-5">
            <h2> <a href="https://www.linkedin.com/in/gregoryswan/" target=" _blank" rel="noopener noreferrer">LinkedIn</a></h2>
            
            <h2> <a href="https://github.com/swanmac" target=" _blank" rel="noopener noreferrer">GitHub</a></h2>
            </div>
        </div>
       
    )
}


